import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

// The day overview (CO-0448) is the agenda view of Werk now (CO-1386, ADR-0038); old links keep working.
const search = z.object({ date: z.string().optional(), view: z.enum(['week', 'day']).optional() });
export const Route = createFileRoute('/_app/agenda')({
  validateSearch: search,
  beforeLoad: ({ search: s }) => {
    throw redirect({
      to: '/werk',
      search: { view: 'agenda', date: s.date, range: s.view === 'week' ? 'week' : undefined },
    });
  },
});
